/**
 * @license
 * Copyright Quizale. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  urls: {
    apiUrl: 'https://api.quizale.com/',
    // apiUrl: 'https://localhost:6301/',
    // apiUrl: 'https://localhost:44318/',
  },
  storage: {
    rootPath: 'https://quizaleprodstg.blob.core.windows.net/',
    quizFiles: 'https://quizaleprodstg.blob.core.windows.net/quiz-files/',
    userPhotos: 'https://quizaleprodstg.blob.core.windows.net/users/',
    logoPath: 'https://quizaleprodstg.blob.core.windows.net/logos/',
  },
  msalConfig: {
    auth: {
      clientId: "cae5be98-8486-4036-988c-ee94ee973dfe",
      // authority: "https://login.microsoftonline.com/common",
      authority: "https://login.microsoftonline.com/15b5d333-ac38-40a8-ae8d-20f3121876ce",
      redirectUri: "http://localhost:6303/auth/login",
      postLogoutRedirectUri: "http://localhost:6303/auth/login",
    },
    cache: {
      cacheLocation: "localStorage", // This configures where your cache will be stored
      storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    }
  },
  loginRequest: {
    scopes: ["openid", "profile", "User.Read"]
  },
};
